import { type ReactNode } from "react";
import { Navigate, useParams } from "react-router";
import { parseMaterialTypeParam } from "utils/materialType";

export function MaterialTypeGate({
  fallback,
  children,
}: {
  fallback: string;
  children: ReactNode;
}) {
  const { typeFilter } = useParams<{ typeFilter?: string }>();
  return parseMaterialTypeParam(typeFilter) ? (
    children
  ) : (
    <Navigate to={fallback} replace />
  );
}
